import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Cliente } from '../cliente.model';
import { BackendService } from '../../core/backend.service';
import { Subcliente } from '../subcliente.model';
import { ResultSubclienteResolver } from './cliente-user-add-edit.component';


@Injectable()
export class UsuarioClienteResolver implements Resolve<ResultSubclienteResolver> {
  constructor(
    protected router: Router,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    let resultado = new ResultSubclienteResolver();

    try {
      const id = route.params.id;

      const isSubcliente = await this.backendService.getBoolean('/subclientes/is-subcliente/' + id);
      

      if (!isSubcliente) {
        
        resultado.padre = await this.backendService.get(Cliente, Cliente.path + id).toPromise();
      } else{
        
        resultado.subcliente = await this.backendService.get(Subcliente, Subcliente.path + id).toPromise();
      }
      return resultado;
     } catch (error) {
      this.router.navigate(['/clientes']);
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/cliente/cliente-user-add-edit/usuario-cliente.resolver.ts